import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import {
  TalkhattabatConversationType,
  TKhattabatMessage,
  TMessagesType
} from "../../../Types";
import React from "react";
import { isDefinedString } from "et3-type-guards";
import { MAX_APP_MESSAGE_LENGTH } from "../../../constants/input-entries-constants";
import getKhattabat101MMessagingStore from "../101m-stores/101m-messaging-store";
import getKhattabat101CMessagingStore from "../101c-stores/101c-messaging-store";
import getKhattabatFilterStore from "../filter-store";

import getKhattabat101MessagingStore from "./101-messaging-store";
import { getFormmatedDate } from "../../../helpers/et3-date-helper";
class KhattabatSharedMessagingStore {
  conversationID = observable.box<string>("");
  conversationType = observable.box<TalkhattabatConversationType>("101C");
  messages = observable.box<TKhattabatMessage[]>([]);
  unreadMessagesCounter = observable.box<number>(0);
  messageField = observable.box<string>("");
  isOpened = observable.box<"OPENED" | "CLOSED">("CLOSED");
  isLoading = observable.box<boolean>(false);
  isSending = observable.box<boolean>(false);
  scrollRef = React.createRef<HTMLDivElement>();
  isSeen = observable.box<1 | 0>(0);
  hasUnreadMessages = observable.box<boolean>(false);

  setMessageField = (value: string) => {
    if (value.length > MAX_APP_MESSAGE_LENGTH) {
      return;
    }
    const isFirstCharacter = !isDefinedString(this.messageField.get());
    const finalizedValue = isFirstCharacter ? value.trim() : value;
    runInAction(() => {
      this.messageField.set(finalizedValue);
    });
  };

  toggleIsOpened = () => {
    const currentState = this.isOpened.get();
    runInAction(() => {
      this.isOpened.set(currentState === "OPENED" ? "CLOSED" : "OPENED");
    });
  };
  setUnreadMessagesCounter = (value: number) => {
    runInAction(() => {
      this.unreadMessagesCounter.set(value);
      this.isSeen.set(value > 0 ? 0 : 1);
      this.hasUnreadMessages.set(value > 0);
    });
  };

  appendMessage = (message: TKhattabatMessage) => {
    runInAction(() => {
      this.messages.set([...this.messages.get(), message]);
    });
    this.scrollToBottom();
  };
  updateMessages = (messages: TKhattabatMessage[]) => {
    runInAction(() => {
      this.messages.set(messages);
    });
  };
  resetMessages = () => {
    runInAction(() => {
      this.messages.set([]);
    });
  };

  appendSentMessage = ({
    message,
    messageType
  }: {
    message: string;
    messageType: TMessagesType;
  }) => {
    const databaseCurrentTime = getFormmatedDate(new Date());
    const conversationType = this.conversationType.get();
    const receiverID = getKhattabat101MessagingStore(
      this.conversationID.get()
    ).receiverID.get();
    const oneOOneMessageToAdd: TKhattabatMessage = {
      isKhattabaMessage: 1,
      isClientMessage: 0,
      message,
      messageType,
      createdOn: databaseCurrentTime,
      isSeen: 1,
      senderGender: "f",
      conversationId: this.conversationID.get()
    };
    const isComments =
      conversationType === "101C_COMMENTS" ||
      conversationType === "101M_COMMENTS";
    const isOneOOneMConversation = conversationType === "101M";

    if (isComments) {
      this.appendMessage(oneOOneMessageToAdd);
    } else {
      const messagingStore = isOneOOneMConversation
        ? getKhattabat101MMessagingStore(receiverID)
        : getKhattabat101CMessagingStore(receiverID);
      messagingStore.handleMessageSent({
        conversationID: this.conversationID.get(),
        oneOOneMessageToAdd
      });
      messagingStore.markMessagesSeen();
    }
    this.setMessageField("");
    getKhattabatFilterStore().update1o1MFilter();
  };

  scrollToBottom = () => {
    if (this.scrollRef.current != null) {
      this.scrollRef.current.scrollTo({
        top: this.scrollRef.current.scrollHeight
      });
    }
  };
}

const getKhattabatSharedMessagingStore = memoize((conversationID: string) => {
  const store = new KhattabatSharedMessagingStore();
  store.conversationID.set(conversationID);
  return store;
});
export default getKhattabatSharedMessagingStore;
